import { t, useLanguage, getLanguage } from "@/i18n/LanguageContext";import { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send, Bot } from "lucide-react";
import { API } from "@/lib/api";
import { Link } from "react-router-dom";

const SUGGESTIONS = [
"Quali servizi offrite?",
"Che certificazioni avete?",
"Come richiedo un preventivo?"];


function getSessionId() {
  let id = localStorage.getItem("gfc_chat_session");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("gfc_chat_session", id);
  }
  return id;
}

function renderRichText(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
  p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{t(p.slice(2, -2))}</strong> : p
  );
}

export default function ChatWidget() {useLanguage();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const patchLast = (content) =>
  setMessages((m) => {
    const c = [...m];
    c[c.length - 1] = { role: "assistant", content };
    return c;
  });

  const appendToken = (t) =>
  setMessages((m) => {
    const c = [...m];
    c[c.length - 1] = { role: "assistant", content: c[c.length - 1].content + t };
    return c;
  });

  const send = async (preset) => {
    const message = (preset ?? input).trim();
    if (!message || busy) return;
    setInput("");
    setMessages((m) => [...m, { role: "user", content: message }, { role: "assistant", content: "" }]);
    setBusy(true);
    try {
      const res = await fetch(`${API}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: getSessionId(), message, language: getLanguage() })
      });
      if (!res.ok || !res.body) throw new Error("bad response");
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop();
        for (const part of parts) {
          const line = part.trim();
          if (!line.startsWith("data:")) continue;
          const data = line.slice(5).trim();
          if (data === "[DONE]") continue;
          try {
            const j = JSON.parse(data);
            if (j.t) appendToken(j.t);
            if (j.error) patchLast(j.error);
          } catch {

            // chunk parziale ignorato
          }}
      }
      setMessages((m) => {
        const c = [...m];
        if (!c[c.length - 1].content) {
          c[c.length - 1] = { role: "assistant", content: "Assistente momentaneamente non disponibile. Riprova tra poco." };
        }
        return c;
      });
    } catch (e) {
      patchLast("Si è verificato un problema di connessione. Riprova tra poco o scrivici dal modulo Contatti.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="chat-widget" className="fixed bottom-5 right-5 z-[60]">
      {t(open ?
      <div className="flex h-[70vh] max-h-[560px] w-[92vw] max-w-sm flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl">
          <div className="flex items-center justify-between bg-brand-navydeep px-5 py-4">
            <div className="flex items-center gap-3">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-brand-lime text-brand-navydeep">
                <Bot className="h-5 w-5" />
                <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border-2 border-brand-navydeep bg-green-400" />
              </span>
              <div>
                <p className="font-display text-sm font-bold text-white">{t("Assistente GFC")}</p>
                <p className="text-[10px] uppercase tracking-widest text-brand-lime">{t("AI · online")}</p>
              </div>
            </div>
            <button data-testid="chat-close-button" onClick={() => setOpen(false)} aria-label={t("Chiudi chat")}
          className="rounded-lg p-1.5 text-white/70 transition-colors hover:bg-white/10 hover:text-white">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="flex-1 space-y-3 overflow-y-auto bg-[#F8FAFC] p-4" data-testid="chat-messages">
            {t(messages.length === 0 &&
          <div>
                <div className="max-w-[85%] rounded-2xl rounded-tl-sm bg-white p-3.5 text-sm leading-relaxed text-slate-700 shadow-sm">{t("Ciao! Sono l'assistente virtuale di ")}
              <strong>{t("GFC Appalti Generali S.r.l.")}</strong>{t(" Chiedimi di servizi, certificazioni, cantieri o contatti.")}
            </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {t(SUGGESTIONS.map((s, i) =>
              <button key={s} data-testid={`chat-suggestion-${i}`} onClick={() => send(t(s))}
              className="rounded-full border border-brand-navy/20 bg-white px-3.5 py-1.5 text-xs font-semibold text-brand-navy transition-colors hover:border-brand-lime hover:bg-brand-limelight">
                      {t(s)}
                    </button>
              ))}
                </div>
              </div>)
          }
            {t(messages.map((m, i) =>
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div
              data-testid={`chat-message-${i}`}
              className={`max-w-[85%] whitespace-pre-wrap rounded-2xl p-3.5 text-sm leading-relaxed shadow-sm ${
              m.role === "user" ?
              "rounded-tr-sm bg-brand-navy text-white" :
              "rounded-tl-sm bg-white text-slate-700"}`
              }>
              
                  {t(renderRichText(t(m.content)) || (busy && i === messages.length - 1 ? "…" : ""))}
                </div>
              </div>
          ))}
            <div ref={bottomRef} />
          </div>

          <div className="border-t border-slate-200 bg-white p-3">
            <p data-testid="chat-privacy-notice" className="mb-2 text-[10px] leading-relaxed text-slate-500">{t("Non inserire dati sensibili nella chat.")} <Link data-testid="chat-privacy-link" to="/privacy" target="_blank" rel="noopener noreferrer" className="font-semibold text-brand-navy underline">{t("Privacy")}</Link></p>
            <div className="flex items-center gap-2">
              <input
              data-testid="chat-input"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder={t("Scrivi un messaggio…")}
              maxLength={1000}
              className="flex-1 rounded-full border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-navy" />
            
              <button data-testid="chat-send-button" onClick={() => send()} disabled={busy || !input.trim()} aria-label={t("Invia")}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-navy text-white transition-colors hover:bg-brand-navydark disabled:opacity-50">
                <Send className="h-4 w-4" />
              </button>
            </div>
            <p className="mt-2 text-center text-[10px] text-slate-400">{t("Risposte generate da AI (Claude) · verifica sempre le informazioni critiche")}</p>
          </div>
        </div> :

      <button data-testid="chat-open-button" onClick={() => setOpen(true)} aria-label={t("Apri assistente")}
      className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-brand-navy text-white shadow-xl transition-transform duration-300 hover:scale-105">
          <MessageCircle className="h-6 w-6" />
          <span className="absolute -right-0.5 -top-0.5 flex h-3.5 w-3.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-lime opacity-75" />
            <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-brand-lime" />
          </span>
        </button>)
      }
    </div>);

}
